
export default {
  name: 'Hamburger',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      const action = this.open ? 'close-menu' : 'open-menu'
      this.$emit(action)
    },
  },
}
